// extracted by mini-css-extract-plugin
export default {"skeleton":"Skeleton_skeleton__OOP+m","skeleton-loading":"Skeleton_skeleton-loading__ieHPJ"};